import { socket } from '../EntryShared.ts';
import { ShuffleAction } from '@colonist/lobby-types';
import { ClientMessageSubType } from '@colonist/types';
export class SocketShuffleSend {
    static send(action, data) {
        const actionDataToSend = {
            action: action,
            payload: data
        };
        socket.controller.sender.sendToServerType(ClientMessageSubType.ShuffleAction, 'lobby', actionDataToSend);
    }
    static requestShuffleQueueData() {
        this.send(ShuffleAction.GetShuffleQueueData, undefined);
    }
}
